export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8207.9b2e9491.jpg";